import { PayloadAction } from "@reduxjs/toolkit";
import { GroupsState } from "../../models/GroupsState";
import { DeleteStudentForGroupPayload } from "../../payload/DeleteStudentForGroup/DeleteStudentForGroupPayload";

const deleteStudentForGroupFetch = (state: GroupsState, action: PayloadAction<DeleteStudentForGroupPayload>) => {
    state.isLoading = true;
}

export default deleteStudentForGroupFetch;